import { render } from "./About.vue?vue&type=template&id=5da3fad2"
const script = {}
script.render = render

export default script